import { ModuleWithProviders, NgModule } from '@angular/core';
import { BaseAuthTokensStorageService } from '@shared/shared/auth/data-access/base-auth-tokens-storage.service';
import { AuthTokensStorageService } from '@shared/shared/auth/data-access/auth-tokens-storage.service';
import { UserAuthService } from '@shared/modules/auth/auth-data-access/user-auth.service';

@NgModule({
  imports: []
})
export class AuthDataAccessModule {
  static forRoot(): ModuleWithProviders<AuthDataAccessModule> {
    return {
      ngModule: AuthDataAccessModule,
      providers: [
        UserAuthService,
        AuthTokensStorageService,
        { provide: BaseAuthTokensStorageService, useExisting: AuthTokensStorageService }
      ]
    };
  }
}
